
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interior-design-ideas",
      function () {
        return require("private-next-pages/interior-design-ideas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interior-design-ideas"])
      });
    }
  